import {Component, ElementRef, OnInit, output, viewChild, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-mfa-num-pad',
    templateUrl: './mfa-num-pad.component.html',
    styleUrls: ['./mfa-num-pad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class MfaNumPadComponent implements OnInit {

  readonly value = output<string>();
  readonly i1 = viewChild<ElementRef<HTMLInputElement>>('i1');
  readonly i2 = viewChild<ElementRef<HTMLInputElement>>('i2');
  readonly i3 = viewChild<ElementRef<HTMLInputElement>>('i3');
  readonly i4 = viewChild<ElementRef<HTMLInputElement>>('i4');
  readonly i5 = viewChild<ElementRef<HTMLInputElement>>('i5');
  readonly i6 = viewChild<ElementRef<HTMLInputElement>>('i6');

  constructor() { }

  ngOnInit(): void {
  }

  onInput(event: KeyboardEvent, inputNext: HTMLInputElement, inputPrev: HTMLInputElement, self: HTMLInputElement) {
    this.calcValuesAndEmit();

    if(event.key === 'Backspace') {

      if(self.value === '')
        setTimeout(()=>inputPrev?.select())

      return;
    }

    /*if((event.target as HTMLInputElement).value.trim().length > 0 && event.key != 'Tab') {
      event.stopPropagation();
      event.preventDefault();
      return
    }*/
    if(event.key != 'Tab')
      setTimeout(()=>inputNext?.select())
  }

  onFocus($event: FocusEvent, input: HTMLInputElement) {
    input.select()
  }

  calcValuesAndEmit() {
    setTimeout(() => {
      const val = '' + this.i1().nativeElement.value + this.i2().nativeElement.value +this.i3().nativeElement.value +this.i4().nativeElement.value +this.i5().nativeElement.value +this.i6().nativeElement.value;
      this.value.emit(val);
    })

  }

}
